import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {OutletPeer} from '@service-and-repairs/awpintegrationlib';
import {map, Observable} from 'rxjs';
import {UserInfo} from '../interfaces/user-info';
import {UserSettings} from '../interfaces/user-settings';

export type OutletPeerScope = 'OUTLET' | 'DISTRIBUTION_PARTNER' | 'ALL';

@Injectable({
  providedIn: 'root'
})
export class UserApiService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly settingsUrl: string = '/api/user/settings/v1';

  getOutletPeers(outletPeerScope?: OutletPeerScope): Observable<OutletPeer[]> {
    const url: string = outletPeerScope
      ? `/api/user/v1?outletPeerScope=${outletPeerScope}`
      : '/api/user/v1';
    return this.httpClient.get<{data: UserInfo}>(url)
      .pipe(map((response: {data: UserInfo}): OutletPeer[] => response.data.outletPeers));
  }

  setUserSettings(settings: UserSettings): Observable<unknown> {
    return this.httpClient.put<unknown>(this.settingsUrl, {data: settings});
  }

  deleteColumnsSettings(): Observable<unknown> {
    return this.httpClient.delete<unknown>('/api/service-case-details/v2/columns-settings');
  }

  deleteUserSettings(): Observable<unknown> {
    return this.httpClient.delete<unknown>(this.settingsUrl);
  }
}
